import { FeatureRequestStatus } from "@/src/models/feature-request.model";

type StatusStyle = Readonly<{
  labelKey: string;
  /** Pill background (tailwind class). */
  pillClassName: string;
  /** Count text inside the white badge — same hue as the pill. */
  countClassName: string;
}>;

export const FEATURE_REQUEST_STATUS_STYLES: Record<
  FeatureRequestStatus,
  StatusStyle
> = {
  open: {
    labelKey: "LABEL_FEATURE_STATUS_OPEN",
    pillClassName: "bg-primary",
    countClassName: "text-primary",
  },
  accepted: {
    labelKey: "LABEL_FEATURE_STATUS_ACCEPTED",
    pillClassName: "bg-jade",
    countClassName: "text-jade",
  },
  rejected: {
    labelKey: "LABEL_FEATURE_STATUS_REJECTED",
    pillClassName: "bg-crimson",
    countClassName: "text-crimson",
  },
  in_progress: {
    labelKey: "LABEL_FEATURE_STATUS_IN_PROGRESS",
    pillClassName: "bg-amber",
    countClassName: "text-amber",
  },
  closed: {
    labelKey: "LABEL_FEATURE_STATUS_CLOSED",
    pillClassName: "bg-slate",
    countClassName: "text-slate",
  },
};
